import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=4359268e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=4359268e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359268e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4359268e')) {
      api.createRecord('4359268e', component.options)
    } else {
      api.reload('4359268e', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=4359268e&scoped=true", function () {
      api.rerender('4359268e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/Docs/vibeo/PrivacyPolicy.vue"
export default component.exports